const data = [ 
{
"id": 1,
"image":"assets/images/recording.jpg" ,
"alt":"Recording session set up.",
"artistName":"Recording Sessions",
"text":"I am available to record on your next album, single, television show jingle, or movie score! I have a ton of different instruments, pedals, and key bass synthesizers to choose from to get the best tone for your project. With over 10 years experience I am able to learn your music on spot or read from a chart if you have a specific part in mind.",
"hover": "Sound on Sound Studios, Montclair, NJ, 2020"
},
{
"id": 2,
"image":"assets/images/danafuchs.jpg",
"alt":"Brian Gearty on stage with Dana Fuchs in San Francisco, CA in 2018.",
"artistName":"Dana Fuchs",
"text":"Since 2017 I have been touring with the wildly entertaining blues/soul artist, Dana Fuchs from Harlem, NY. Dana played the character, 'Sexy Sadie' in the cult classic, 'Across The Universe.' Dana has a distinct rasp in her voice many compare to Janis Joplin while remaining smooth and soulful. We can be seen and heard all across the United States and Europe.",
"hover": "Dana Fuchs, Biscuits and Blues, 2018"
},
{
"id": 3,
"image":"assets/images/nicoleatkins.jpg",
"alt":"Brian Gearty on stage with Nicole Atkins in Asbury Park, NJ in 2018",
"artistName":"Nicole Atkins",
"text":"I have had the distinct pleasure of sharing the stage with Nicole Atkins through-out the years. Nicole is often compared to Roy Orbison and many others from the 195 'crooner' era as well as 1960's pschedelic soul. She is coined with The Golden Voice. Her charming delivery and deep rooted vocals bring listeners to a different time and space.",
"hover": "Nicole Atkins, Wonder Bar, 2017"
},
{
"id": 4,
"image":"assets/images/gedeonluke.jpg",
"alt":"Brian Gearty on stage with Gedon Luke & the People in Memphis, TN 2017.",
"artistName":"Gedeon Luke & the People",
"text":"Gedeon and the band are an act to see. Forget about your day job. Forget about your struggles you're going to be hit with a wall of Funk n' Soul. Gedeon grew up in Memphis and grasped the attention of producers all over the country when he made it to the final round of American Idol some years back. Its a big band fusing Funk, Soul, Rock, Blues and Gospel music.",
"hover": "Gedeon Luke, Memphis Levitt Shell, 2016"
},
{
"id": 5,
"image":"assets/images/mikeorlando.jpg",
"alt":"Brian Gearty on stage with Mike Orlando and Corey Glover at Iridium Jazz Club 2019.",
"artistName":"Corey Glover & Mike Orlando",
"text":"I got a call to do a music video with a metal band from Norway. I dont play metal! I did it and it lead to me getting hired by the guitarist Mike Orlando of 'Adrenaline Mob' and vocalist Corey Glover of 'Living Colour.' Their original music was a fusion of hard rock, metal, and composition-like classical music. To say the least that was one of the most rewarding gigs I have ever done.",
"hover": "Mike Orlando, Iridium Jazz Club NYC, 2019"
},
{
"id": 6,
"image":"assets/images/flybymidnight.jpg",
"alt":"Brian Gearty on stage with Fly By Midnight at Firefly Fest 2019.",
"artistName":"Fly By Midnight",
"text":"Retro-Pop Duo Fly By Midnight out of New York City. I have the pleasure of doing a bunch with these guys. They write and produce EVERYTHING in house. You dont find that with many acts these days. These guys have got the feel good-upbeat jams that keep you movin'. We hit a bunch of great festivals and venues together including Firefly Music Festival, Panorama Music Festival, and the Rainbow Room.",
"hover": "Fly By Midnight, Firefly Festival, 2018"
}
]

export default data;